module.exports = __webpack_public_path__ + "media/icons/menu-36c3d03a.png";